var _$CancelToken_5 = {};
"use strict";

/* removed: var _$Cancel_4 = require("./Cancel"); */;

function CancelToken(executor) {
  if ("function" != typeof executor) throw new TypeError("executor must be a function.");
  var resolvePromise;
  this.promise = new Promise(function (resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function (message) {
    token.reason || (token.reason = new _$Cancel_4(message), resolvePromise(token.reason));
  });
}

CancelToken.prototype.throwIfRequested = function () {
  if (this.reason) throw this.reason;
}, CancelToken.source = function () {
  var cancel;
  return {
    token: new CancelToken(function (c) {
      cancel = c;
    }),
    cancel: cancel
  };
}, _$CancelToken_5 = CancelToken;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhbmNlbFRva2VuLmpzIl0sIm5hbWVzIjpbIkNhbmNlbFRva2VuIiwiZXhlY3V0b3IiLCJUeXBlRXJyb3IiLCJyZXNvbHZlUHJvbWlzZSIsInRoaXMiLCJwcm9taXNlIiwiUHJvbWlzZSIsInJlc29sdmUiLCJ0b2tlbiIsIm1lc3NhZ2UiLCJyZWFzb24iLCJDYW5jZWwiLCJwcm90b3R5cGUiLCJ0aHJvd0lmUmVxdWVzdGVkIiwic291cmNlIiwiY2FuY2VsIiwiYyIsIm1vZHVsZSJdLCJtYXBwaW5ncyI6IjtBQUFBLFlBQUEsQ0FBQTs7QUFFQSxxREFBQTs7QUFRQSxTQUFTQSxXQUFULENBQXFCQyxRQUFyQixFQUFxQkE7RUFDbkIsSUFBd0IsVUFBQSxJQUFBLE9BQWJBLFFBQVgsRUFDRSxNQUFNLElBQUlDLFNBQUosQ0FBYyw4QkFBZCxDQUFOLENBQUE7RUFHRixJQUFJQyxjQUFKLENBQUE7RUFDQUMsSUFBQUEsQ0FBS0MsT0FBTEQsR0FBZSxJQUFJRSxPQUFKLENBQVksVUFBeUJDLE9BQXpCLEVBQXlCQTtJQUNsREosY0FBQUEsR0FBaUJJLE9BQWpCSixDQUFBQTtHQURhLENBQWZDLENBQUFBO0VBSUEsSUFBSUksS0FBQUEsR0FBUUosSUFBWixDQUFBO0VBQ0FILFFBQUFBLENBQVMsVUFBZ0JRLE9BQWhCLEVBQWdCQTtJQUNuQkQsS0FBQUEsQ0FBTUUsTUFBTkYsS0FLSkEsS0FBQUEsQ0FBTUUsTUFBTkYsR0FBZSxJQUFJRyxVQUFKLENBQVdGLE9BQVgsQ0FBZkQsRUFDQUwsY0FBQUEsQ0FBZUssS0FBQUEsQ0FBTUUsTUFBckJQLENBTklLLENBQUFBLENBQUFBO0dBRE5QLENBQUFBLENBQUFBO0NBY0ZEOztBQUFBQSxXQUFBQSxDQUFZWSxTQUFaWixDQUFzQmEsZ0JBQXRCYixHQUF5QyxZQUFBO0VBQ3ZDLElBQUlJLElBQUFBLENBQUtNLE1BQVQsRUFDRSxNQUFNTixJQUFBQSxDQUFLTSxNQUFYLENBQUE7Q0FGSlYsRUFVQUEsV0FBQUEsQ0FBWWMsTUFBWmQsR0FBcUIsWUFBQTtFQUNuQixJQUFJZSxNQUFKLENBQUE7RUFJQSxPQUFPO0lBQ0xQLEtBQUFBLEVBSlUsSUFBSVIsV0FBSixDQUFnQixVQUFrQmdCLENBQWxCLEVBQWtCQTtNQUM1Q0QsTUFBQUEsR0FBU0MsQ0FBVEQsQ0FBQUE7S0FEVSxDQUdMO0lBRUxBLE1BQUFBLEVBQVFBLE1BQUFBO0dBRlYsQ0FBQTtDQWZGZixFQXFCQWlCLGVBQUFBLEdBQWlCakIsV0FyQmpCQSxDQUFBQSIsInNvdXJjZXNDb250ZW50IjpbbnVsbF19